export default __webpack_public_path__ + "static/ab-34856ce1db6464336993cd3baa1fa5ad.png";